module.exports = __webpack_public_path__ + "static/media/certificateIconFooter.67798bae.png";